<template>
  <div class="contact-us">
    <!-- 可拖拽悬浮按钮 -->
    <div
      ref="contactBtn"
      class="contact-us-button"
      :style="buttonStyle"
      @mousedown="onDragStart"
      @click="onButtonClick"
      @touchstart.passive="onTouchStart"
      @touchmove.prevent="onTouchMove"
      @touchend="onTouchEnd"
    >
      <i class="el-icon-chat-line-square"></i>
      <span>{{ $t('contact.button') }}</span>
    </div>

    <!-- 联系方式对话框 -->
    <el-dialog
      :title="$t('contact.dialogTitle')"
      :visible.sync="showDialog"
      :width="dialogWidth"
      :close-on-click-modal="true"
      :append-to-body="true"
      custom-class="contact-dialog-panel"
      class="contact-dialog"
      @close="handleDialogClose"
    >
      <div class="contact-content">
        <!-- 邮箱 -->
        <div class="contact-item">
          <div class="contact-label">
            <i class="el-icon-message"></i>
            <span>{{ $t('contact.email') }}</span>
          </div>
          <div class="contact-value">
            <a :href="`mailto:${contactInfo.email}`">{{ contactInfo.email }}</a>
          </div>
        </div>

        <!-- 公司地址 -->
        <div class="contact-item">
          <div class="contact-label">
            <i class="el-icon-location"></i>
            <span>{{ $t('contact.address') }}</span>
          </div>
          <div class="contact-value">
            {{ contactInfo.address }}
          </div>
        </div>

        <!-- WhatsApp -->
        <div class="contact-item">
          <div class="contact-label">
            <i class="el-icon-phone"></i>
            <span>{{ $t('contact.whatsapp') }}</span>
          </div>
          <div class="contact-value">
            <a :href="whatsappUrl" target="_blank" rel="noopener noreferrer">
              {{ contactInfo.whatsapp }}
            </a>
          </div>
        </div>

        <!-- 微信 & WhatsApp 二维码 -->
        <div class="contact-item">
          <div class="contact-label">
            <i class="el-icon-chat-line-round"></i>
            <span>{{ $t('contact.wechat') }}</span>
          </div>
          <div class="contact-value wechat-value">
            <div class="wechat-info">
              <span class="wechat-id">{{ contactInfo.wechat }}</span>
              <el-button 
                type="text" 
                size="mini" 
                @click="copyWeChat"
                class="copy-btn"
              >
                {{ $t('contact.copy') }}
              </el-button>
            </div>
            <div class="qrcode-row">
              <div class="qrcode-item">
                <img 
                  :src="contactInfo.wechatQrcode" 
                  alt="WeChat QR code"
                  @error="handleQrcodeError"
                />
                <p class="qrcode-hint">{{ $t('contact.wechatQrHint') }}</p>
              </div>
              <div class="qrcode-item">
                <img 
                  :src="contactInfo.whatsappQrcode" 
                  alt="WhatsApp QR code"
                  @error="handleWhatsappQrcodeError"
                />
                <p class="qrcode-hint">{{ $t('contact.whatsappQrHint') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  data() {
    return {
      showDialog: false,
      isMobile: false,
      position: { left: null, top: null },
      drag: { active: false, startX: 0, startY: 0, startLeft: 0, startTop: 0 },
      justDragged: false,
      touchDrag: { active: false, startX: 0, startY: 0, startLeft: 0, startTop: 0 },
      contactInfo: {
        email: 'jxautoparts@yahoo.com', // 公司邮箱
        address: 'Room3807-08,Building 1,Wuyue Plaza,Hutang,Wujin District,Changzhou,Jiangsu,China', // 公司地址
        whatsapp: '86-15295093701', // WhatsApp号码（显示用）
        whatsappNumber: '8615305159157', // WhatsApp号码（链接用，国际格式，不含+号）
        wechat: 'skyautomax-service', // 微信号
        wechatQrcode: '/static/img/wechat.jpg', // 微信二维码图片URL
        whatsappQrcode: '/static/img/whatsapp.jpg' // WhatsApp 二维码图片URL
      }
    };
  },
  computed: {
    dialogWidth() {
      return this.isMobile ? '92%' : '500px';
    },
    whatsappUrl() {
      return `https://wa.me/${this.contactInfo.whatsappNumber}`;
    },
    buttonStyle() {
      if (this.position.left != null && this.position.top != null) {
        return {
          left: this.position.left + 'px',
          top: this.position.top + 'px',
          right: 'auto',
          bottom: 'auto'
        };
      }
      return {};
    }
  },
  created() {
    this.updateIsMobile();
  },
  mounted() {
    window.addEventListener('resize', this.updateIsMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  methods: {
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    onDragStart(e) {
      if (e.button !== undefined && e.button !== 0) return;
      if (e.preventDefault) e.preventDefault();
      const el = this.$refs.contactBtn;
      if (!el) return;
      if (this.position.left == null) {
        const rect = el.getBoundingClientRect();
        this.position = { left: rect.left, top: rect.top };
      }
      this.drag = {
        active: true,
        startX: e.clientX,
        startY: e.clientY,
        startLeft: this.position.left,
        startTop: this.position.top
      };
      document.addEventListener('mousemove', this.onDragMove);
      document.addEventListener('mouseup', this.onDragEnd);
    },
    onDragMove(e) {
      if (!this.drag.active) return;
      const dx = e.clientX - this.drag.startX;
      const dy = e.clientY - this.drag.startY;
      const el = this.$refs.contactBtn;
      let left = this.drag.startLeft + dx;
      let top = this.drag.startTop + dy;
      if (el) {
        left = Math.max(0, Math.min(left, window.innerWidth - el.offsetWidth));
        top = Math.max(0, Math.min(top, window.innerHeight - el.offsetHeight));
      }
      this.position = { left, top };
    },
    onDragEnd() {
      const moved = this.drag.active && (
        Math.abs(this.position.left - this.drag.startLeft) > 5 ||
        Math.abs(this.position.top - this.drag.startTop) > 5
      );
      this.justDragged = moved;
      this.drag = { active: false, startX: 0, startY: 0, startLeft: 0, startTop: 0 };
      document.removeEventListener('mousemove', this.onDragMove);
      document.removeEventListener('mouseup', this.onDragEnd);
    },
    onButtonClick() {
      if (this.justDragged) {
        this.justDragged = false;
        return;
      }
      this.showDialog = true;
    },
    onTouchStart(e) {
      const el = this.$refs.contactBtn;
      if (!el || !e.touches.length) return;
      if (this.position.left == null) {
        const rect = el.getBoundingClientRect();
        this.position = { left: rect.left, top: rect.top };
      }
      this.touchDrag = {
        active: true,
        startX: e.touches[0].clientX,
        startY: e.touches[0].clientY,
        startLeft: this.position.left,
        startTop: this.position.top
      };
    },
    onTouchMove(e) {
      if (!this.touchDrag.active || !e.touches.length) return;
      const dx = e.touches[0].clientX - this.touchDrag.startX;
      const dy = e.touches[0].clientY - this.touchDrag.startY;
      const el = this.$refs.contactBtn;
      let left = this.touchDrag.startLeft + dx;
      let top = this.touchDrag.startTop + dy;
      if (el) {
        left = Math.max(0, Math.min(left, window.innerWidth - el.offsetWidth));
        top = Math.max(0, Math.min(top, window.innerHeight - el.offsetHeight));
      }
      this.position = { left, top };
    },
    onTouchEnd() {
      const moved = this.touchDrag.active && (
        Math.abs(this.position.left - this.touchDrag.startLeft) > 5 ||
        Math.abs(this.position.top - this.touchDrag.startTop) > 5
      );
      this.justDragged = moved;
      this.touchDrag = { active: false, startX: 0, startY: 0, startLeft: 0, startTop: 0 };
    },
    // 复制微信号
    copyWeChat() {
      const text = this.contactInfo.wechat;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success(this.$t('tip.wechatCopied'));
        }).catch(() => {
          this.fallbackCopyText(text);
        });
      } else {
        this.fallbackCopyText(text);
      }
    },
    // 兼容旧浏览器的复制方法
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.$message.success(this.$t('tip.wechatCopied'));
      } catch (err) {
        this.$message.error(this.$t('tip.copyFailedManual', { text }));
      }
      document.body.removeChild(textArea);
    },
    // 处理微信二维码图片加载错误
    handleQrcodeError(event) {
      event.target.src = 'https://via.placeholder.com/200x200/f5f5f5/999999?text=WeChat+QR';
    },
    // 处理 WhatsApp 二维码图片加载错误
    handleWhatsappQrcodeError(event) {
      event.target.src = 'https://via.placeholder.com/200x200/f5f5f5/999999?text=WhatsApp+QR';
    },
    // 处理对话框关闭后可能残留的遮罩层
    handleDialogClose() {
      this.showDialog = false;
      this.$nextTick(() => {
        setTimeout(() => {
          const modals = document.querySelectorAll('.v-modal');
          const allDialogs = document.querySelectorAll('.el-dialog__wrapper');
          let hasVisibleDialog = false;

          allDialogs.forEach(dialog => {
            const style = window.getComputedStyle(dialog);
            if (style.display !== 'none' && style.opacity !== '0') {
              hasVisibleDialog = true;
            }
          });

          if (!hasVisibleDialog && modals.length > 0) {
            modals.forEach(modal => {
              if (modal && modal.parentNode) {
                modal.parentNode.removeChild(modal);
              } else {
                modal.remove();
              }
            });
            document.body.style.overflow = '';
          }
        }, 350);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.contact-us {
  .contact-us-button {
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 9999;
    background: linear-gradient(135deg, #DC143C 0%, #B22222 100%);
    color: #fff;
    padding: 12px 24px;
    border-radius: 30px;
    box-shadow: 0 4px 12px rgba(220, 20, 60, 0.4);
    cursor: grab;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 500;
    transition: background 0.3s ease, box-shadow 0.3s ease;
    user-select: none;

    i {
      font-size: 20px;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(220, 20, 60, 0.5);
      background: linear-gradient(135deg, #FF1744 0%, #DC143C 100%);
    }

    &:active {
      transform: translateY(0);
      cursor: grabbing;
    }
  }
}

.contact-dialog {
  ::v-deep .el-dialog__body {
    padding: 30px;
  }

  .contact-content {
    .contact-item {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }

      .contact-label {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
        font-size: 16px;
        font-weight: 600;
        color: #303133;

        i {
          font-size: 18px;
          color: #DC143C;
        }
      }

      .contact-value {
        color: #606266;
        font-size: 15px;
        line-height: 1.6;

        a {
          color: #DC143C;
          text-decoration: none;
          transition: color 0.3s;

          &:hover {
            color: #66b1ff;
            text-decoration: underline;
          }
        }

        &.wechat-value {
          .wechat-info {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;

            .wechat-id {
              font-size: 15px;
              color: #303133;
              font-weight: 500;
            }

            .copy-btn {
              padding: 5px 10px;
              font-size: 13px;
            }
          }

          .qrcode-row {
            display: flex;
            justify-content: space-between;
            gap: 16px;
            padding: 20px;
            background: #f5f7fa;
            border-radius: 8px;

            .qrcode-item {
              flex: 1;
              text-align: center;

              img {
                width: 200px;
                height: 200px;
                display: block;
                margin: 0 auto 15px;
                border: 1px solid #e4e7ed;
                border-radius: 4px;
                background: #fff;
              }

              .qrcode-hint {
                margin: 0;
                font-size: 14px;
                color: #909399;
              }
            }
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .contact-us {
    .contact-us-button {
      bottom: 20px;
      right: 20px;
      padding: 10px 14px;
      font-size: 14px;

      i {
        font-size: 18px;
      }

      span {
        display: none;
      }
    }
  }

  .contact-dialog {
    ::v-deep .el-dialog__body {
      padding: 16px;
    }

    .contact-content {
      .contact-item {
        margin-bottom: 20px;

        .contact-label {
          font-size: 14px;
          margin-bottom: 8px;

          i {
            font-size: 16px;
          }
        }

        .contact-value {
          font-size: 13px;
          word-break: break-word;

          &.wechat-value {
            .wechat-info {
              flex-wrap: wrap;
              gap: 8px;
              margin-bottom: 12px;
            }

            .qrcode-row {
              flex-direction: column;
              gap: 12px;
              padding: 12px;

              .qrcode-item {
                img {
                  width: min(160px, 70vw);
                  height: min(160px, 70vw);
                  margin-bottom: 8px;
                }

                .qrcode-hint {
                  font-size: 12px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@media (max-width: 768px) {
  .contact-dialog-panel {
    width: 92% !important;
    margin: 3vh auto !important;
    max-height: 94vh;
    display: flex;
    flex-direction: column;

    .el-dialog__body {
      flex: 1 1 auto;
      min-height: 0;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      padding: 16px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/ContactUs.vue